import React from "react";
import Section1 from "../components/Home/Section1";
import Section2 from "../components/Home/Section2";
import Section3 from "../components/Home/Section3";
import Section4 from "../components/Home/Section4";
import Section5 from "../components/Home/Section5";
import Footer from "../components/Footer";
import IconWhatsapp from "../assets/icons/whatsapp.svg";

const Home = () => {
  return (
    <div
      className="w-screen bg-[#414141] 
                 md:h-screen md:overflow-y-scroll md:snap-y md:snap-mandatory
                 overflow-x-hidden" // 🔒 deshabilita scroll horizontal
    >
      <section className="h-auto md:min-h-screen w-full md:snap-start flex items-center justify-center">
        <Section1 />
      </section>

      <section id="nosotros" className="h-auto md:min-h-screen w-full md:snap-start flex items-center justify-center">
        <Section2 />
      </section>

      <section id="que-hacemos" className="h-auto md:min-h-screen w-full md:snap-start flex items-center justify-center">
        <Section3 />
      </section>

      <section className="h-auto md:min-h-screen w-full md:snap-start flex items-center justify-center">
        <Section4 />
      </section>

      <section id="proyectos-clientes" className="h-auto md:min-h-screen w-full md:snap-start flex items-center justify-center">
        <Section5 />
      </section>
      
      <Footer />

      {/* Botón flotante WhatsApp */}
      <a
        href="https://wa.me/5491144183407"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 bottom-4 sm:bottom-10 sm:right-10 z-50 p-1 rounded-full shadow-lg hover:scale-110 transition-transform"
      >
        <img src={IconWhatsapp} alt="WhatsApp" className="w-10 h-10 sm:w-14 sm:h-14" />
      </a>
    </div>
  );
};

export default Home;